import React, { Component } from 'react'
import '../../css/BisharatMain.css';
import Moment from 'moment';
import Calendar from 'react-calendar';
import PartnerService from '../../services/PartnerService';
export default class PartnerEdit extends Component {
    constructor() {
        super()
        this.state = {
            onePartner: [],
            familyName: '',
            birthdate : new Date(),
            fatherName: '',
            gender: '',
            motherName: '',
            name: '',
            phoneNumber: '',
            errors: {}
        };

        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);

    }


onChangeDate = birthdate => this.setState({birthdate});

    componentDidMount() {
        const { match: { params } } = this.props;
        const partnerId = params.id;
        PartnerService.getPartner(partnerId)
            .then(res => {
                const onePartner = res.data;
                this.setState({ onePartner });
                this.setState({ fatherName : onePartner.fatherName });
                // this.setState({ birthdate : onePartner.birthdate });
                this.setState({ familyName : onePartner.familyName });
                this.setState({ gender : onePartner.gender });
                this.setState({ motherName : onePartner.motherName });
                this.setState({ name : onePartner.name });
                this.setState({ phoneNumber : onePartner.phoneNumber });
            })
    }


    editPartner(data, id) {
        PartnerService.updatePartner(id, data)
            .then((response) => {
                alert("Submitted Successfully !");
            })
            .catch((err) => {

                alert("Error : " + err.response.data.message);
            });
    }


    /* On Change for All Fields */


    onChange = e => {
        this.setState(prev => ({
            ...prev,
            [e.target.name]: e.target.value,
        }))
    }
   

    onSubmit(event) {
        event.preventDefault()

        const newPartner = {
            birthdate: Moment(this.state.birthdate).format('DD-MM-YYYY'),
            fatherName: this.state.fatherName,
            gender: this.state.gender,
            motherName: this.state.motherName,
            familyName: this.state.familyName,
            name: this.state.name,
            phoneNumber: this.state.phoneNumber
        };
        this.editPartner(newPartner, this.state.onePartner.id);
    }


    showPartner(id) {
        window.location.href = `/family-members/${id}`;
}
    addPartner(id) {
    window.location.href = `/family-members/createpartner/${id}`;
}
   


    render() {
        return (
            <div className="mainCreate">
                <div className="top-container-forms memberedit">

                    <div className="create-form memberedit-form">

                        <h1>  تعديل ملف :  {this.state.onePartner.name} </h1>

                        <form onSubmit={this.onSubmit}>
                            <div className="form-group-create">
                                <h5> الأسم </h5>
                                <input type="text"
                                    name="name" placeholder={this.state.onePartner.name}
                                    value={this.state.name}
                                    onChange={this.onChange}
                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الأب </h5>
                                <input type="text" className="form-control-form-cont" name="fatherName" placeholder={this.state.onePartner.fatherName}
                                    value={this.state.fatherName}
                                    onChange={this.onChange}

                                />

                            </div>
                            <div className="form-group-create">
                                <h5> اسم الأم </h5>
                                <input type="text" className="form-control-form-cont" name="motherName" placeholder={this.state.onePartner.motherName}
                                    value={this.state.motherName}
                                    onChange={this.onChange}
                                />
                            </div>
                            <div className="form-group-create">
                                <h5> اسم العائلة </h5>
                                <input type="text" className="form-control-form-cont" name="motherName" placeholder={this.state.onePartner.familyName}
                                    value={this.state.familyName}
                                    onChange={this.onChange}
                                />
                            </div>

                            <div className="form-group-create">
                                <h5> رقم الهاتف </h5>
                                <input type="text" className="form-control-form-cont" name="phoneNumber" placeholder={this.state.onePartner.phoneNumber}
                                    value={this.state.phoneNumber}
                                    onChange={this.onChange}
                                />
                            </div>

                            <div className="form-group-create">
                                <h5> تاريخ الميلاد </h5>
                                   <Calendar className="react-calendar"
                                    onChange={this.onChangeDate}
    
                                    />
                            </div>
                            <div className="form-group-create">
                                <h5> الجنس </h5>
                                <select className="form-control-form-cont" name="gender" onChange={this.onChange} >
                                    <option value="">{this.state.onePartner.gender && "ذكر"} </option>
                                    <option value="female">انثى</option>
                                    <option value="male">ذكر</option>

                                </select>
                            </div>
                          
                        
                          
                            <input type="submit" value="ارسال" className="btn btn-primary btn-block mt-4" />

                        </form>
                        <button className="btn" onClick={this.props.history.goBack}> للعودة  </button>
                    </div>

                </div></div>


        )
    }

}